import * as React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '@mui/joy/Button';
import Divider from '@mui/joy/Divider';
import DialogTitle from '@mui/joy/DialogTitle';
import DialogContent from '@mui/joy/DialogContent';
import DialogActions from '@mui/joy/DialogActions';
import Modal from '@mui/joy/Modal';
import ModalDialog from '@mui/joy/ModalDialog';
import WarningRoundedIcon from '@mui/icons-material/WarningRounded';

export default function DeleteAlert({open, onDelete, onClose, loading, label}) {
  const { t } = useTranslation('ui');
  return (
    <React.Fragment>
      <Modal open={open} onClose={onClose}>
        <ModalDialog variant="outlined" role="alertdialog">
          <DialogTitle>
            <WarningRoundedIcon />
            {t('deleteAlert.title')}
          </DialogTitle>
          <Divider />
          <DialogContent>
            {t('deleteAlert.message', { label })}
          </DialogContent>
          <DialogActions>
            <Button loading = {loading} variant="solid" color="danger" onClick={loading?null:onDelete}>
              {t('deleteAlert.deleteLabel', { label })}
            </Button>
            <Button variant="plain" color="neutral" onClick={onClose}>
              {t('actions.cancel')}
            </Button>
          </DialogActions>
        </ModalDialog>
      </Modal>
    </React.Fragment>
  );
}
